import { postWithValidate } from "../helpers/request";

export const createGroup = async (newGroupName: string) => {
    return await postWithValidate(`/api/groups/create`, {
        name: newGroupName,
    });
};
